import { useQuery } from "@tanstack/react-query";
import { fetchNounSvg } from "@/lib/avatar-presets";

export function useNounSvg(nounId: number) {
  return useQuery({
    queryKey: ["noun-svg", nounId],
    queryFn: () => fetchNounSvg(nounId),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
  });
}
